import styled, { css } from 'styled-components'
import { fontSize, fontWeight, unit, color } from 'ui/themes/utils'

import H2 from 'ui/elements/H2'
import P from 'ui/elements/P'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  max-height: ${({ maxHeight }) => maxHeight};

  overflow-y: auto;

  gap: ${unit('2')};

  padding: ${unit('4')} ${unit('2')};

  background-color: ${color('Background/Primary')};

  border-radius: ${unit('2')};
`

export const Cleanstate = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: 400px;
  width: ${({ width }) => width};

  text-align: center;

  ${H2} {
    font-size: ${unit('4')};
    font-weight: ${fontWeight('semibold')};

    color: ${color('Text/Primary')};
  }

  ${P} {
    font-size: ${unit('3')};

    color: ${color('Text/Tertiary')};
  }
`

export const Durations = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`

export const Duration = styled.button`
  appearance: none;

  border: none;

  background: transparent;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: ${unit('1')};

  margin: 0 ${unit('2')};
  padding: ${unit('2')} ${unit('2')};

  border-radius: ${unit('2')};

  color: ${color('Text/Primary')};

  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('semibold')};
  font-family: ${({ theme }) => theme.font.body};

  cursor: pointer;

  white-space: nowrap;

  &:not(:disabled):hover {
    background-color: ${color('Secondary/Background1')};
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${color('Primary/Background2')};

      &:hover {
        background-color: ${color('Primary/Background2')};
      }
    `}
`
